// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import AccountOpeningAgreementV2Template
  from 'Views/Page/Content/Templates/WizardTemplates/AccountOpeningAgreementTemplate/AccountOpeningAgreementV2Component';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const AccountOpeningAgreementV2TemplatePicker = ({ resource, ...rest }) => {
  const { loadPageContentLink } = usePageContentContext();


  const handleNext = pick(resource, {
    [fr.relationships.activationTest.name]: null,
    [fr.relationships.accountRetitlingWizard.name]: null,
  }, async () => {
    const [nextStep] = await resource.submit();
    loadPageContentLink(nextStep.relationship(fr.relationships.CIPWizard.name).link('related'));
  });

  return <AccountOpeningAgreementV2Template resource={resource} handleNext={handleNext} {...rest} />;
};

export default AccountOpeningAgreementV2TemplatePicker;
